import React, { useEffect, useMemo, useState } from 'react';
import { UserLiteData } from '../../../api/ApiTypes';
import { Button, Input } from '../../../ui';
import { LoadingGuard } from '../../../ui/LoadingGuard';
import { PageButtonStrip } from '../../../ui/PageButtonStrip';
import { FlexScroller } from '../../../ui/Scrollers';
import { useLocationValue } from '../../AppLocation';
import { DataTable } from '../../common/DataTable';
import { Copy, Flexer } from '../elements/LayoutElements';
import { ImportTasksPopup } from './ImportTasksPopup';
import { useTaskQuery } from './TaskQueries';
import { useTaskTableModel } from './TaskTable';
import { TaskTableTheme } from './TaskTableTheme';
import { TasksUserFilter } from './TasksUserFilter';

export const importTasksPopup = () => ({ ui: ImportTasksPopup });

export const SelectTasksView = ({ onSelect }: { onSelect(items: any[]): void }) => {

    const workspaceId = useLocationValue('workspace');
    const [selectedUsers, setSelectedUsers] = useState([] as UserLiteData[]);

    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('');
    const [startAt, setStartAt] = useState(0);
    const userFilter = useMemo(() => selectedUsers.map(x => x.id), [selectedUsers]);
    const [statusFilter, setStatusFilter] = useState('');
    const { data, isInitialLoading } = useTaskQuery({ workspaceId, search, userFilter, statusFilter, sort, startAt });

    const hasFilters = !!search || !!userFilter.length || !!statusFilter;
    const onClearFilters = () => {
        setSearch('');
        setSelectedUsers([]);
        setStatusFilter('');
    };

    // Reset startAt on search
    useEffect(() => {
        setStartAt(0);
    }, [search]);

    const { table, selection } = useTaskTableModel({
        items: data?.items ?? [],
        readonly: true,
        onSortChange: setSort,
    });

    return <LoadingGuard loading={isInitialLoading}>
        <Flexer flex="row" gap="1" align="center" justify="space-between">
            <Flexer flex="row" gap="1" align="center">
                <Flexer width="20">
                    <Input placeholder="Search" value={search} onChange={setSearch} />
                </Flexer>
                <TasksUserFilter {...{ workspaceId, selected: selectedUsers, onSelect: setSelectedUsers }} />
                {hasFilters && <Button variant="text" onAction={onClearFilters}>Clear Filters</Button>}
            </Flexer>
            <Flexer flex="row" gap="1" align="center" shrink>
                <PageButtonStrip data={data} onPageChange={setStartAt} />
            </Flexer>
        </Flexer>
        <Flexer height="1" />
        <FlexScroller>
            {data && <DataTable theme={TaskTableTheme} table={table} />}
        </FlexScroller>
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer>
                <Copy flush>{selection.length} items selected.</Copy>
            </Flexer>
            <Flexer>
                <Button variant="primary" onAction={() => onSelect(selection)}>Import</Button>
            </Flexer>
        </Flexer>
    </LoadingGuard>;
};
